import {
  list_of_default
} from "./chunk-H4ZECW7F.js";

// src/layouts/list-of/index.ts
var list_of_default2 = list_of_default;

export {
  list_of_default2 as list_of_default
};
